import { OUTCOMES_SET, OUTCOME_ADDED, OUTCOME_DELETED, OUTCOME_EDITED } from 'src/app/redux/redux-types';
import { reduxOutcomeTypes } from 'src/types';

export const outcomeDefaultState: reduxOutcomeTypes.StateType = {
  outcomeList: [],
};

export const outcomeReducer = (
  state = outcomeDefaultState,
  action: reduxOutcomeTypes.ActionType,
): reduxOutcomeTypes.StateType => {
  switch (action.type) {
    case OUTCOMES_SET:
      return {
        ...state,
        outcomeList: action.payload,
      };
    case OUTCOME_ADDED:
      // eslint-disable-next-line no-case-declarations
      const exists = state.outcomeList.some((item) => item.id === action.payload.id);
      if (exists) {
        return state;
      }
      return {
        ...state,
        outcomeList: [action.payload, ...state.outcomeList],
      };
    case OUTCOME_EDITED:
      // eslint-disable-next-line no-case-declarations
      const updateIndex = state.outcomeList.findIndex((obj) => obj.id === action.payload.id);
      return {
        ...state,
        outcomeList: [
          ...state.outcomeList.slice(0, updateIndex),
          action.payload,
          ...state.outcomeList.slice(updateIndex + 1),
        ],
      };
    case OUTCOME_DELETED:
      return {
        ...state,
        outcomeList: state.outcomeList.filter((o) => o.id !== action.payload),
      };
    default:
      return state;
  }
};
